export default __webpack_public_path__ + "static/media/digistore_deliveries_logo.24e3ed9e.png";